import styled from 'styled-components';

export const RedButton = styled.button`
  background-color: #e03030;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  padding: 5px 1.5rem;
  margin-bottom: 30px;
  cursor: pointer;
  color: white;

  :hover {
    background-color: #ef4444;
    transform: scale(0.95);
  }
`;
